export const FETCH_IS_TEMPORARY_PAGE_START = 'temporary-homepage/FETCH_IS_TEMPORARY_PAGE_START';
export const FETCH_IS_TEMPORARY_PAGE_COMPLETED = 'temporary-homepage/FETCH_IS_TEMPORARY_PAGE_COMPLETED';
export const FETCH_IS_TEMPORARY_PAGE_FAILED = 'temporary-homepage/FETCH_IS_TEMPORARY_PAGE_FAILED';
